import React, { useState } from "react";
import Image from "components/image";
import RichText from "components/rich-text";
import Modal from "components/modal";
import { ReactComponent as Arrow } from "svgs/small-right-arrow.svg";
import { ReactComponent as GoldArrow } from "svgs/gold-arrow.svg";
import clsx from "clsx/lite";
import Video from "components/video";

const ExpandedMediaModal = ({ isOpen, onClose, images }) => {
	const [currentIndex, setCurrentIndex] = useState(0);
	const changeImage = (step) => setCurrentIndex((prev) => (prev + step + images.length) % images.length);

	return (
		<Modal title="Installation Guide" isOpen={isOpen} close={onClose}
			className="max-w-lg max-h-[95vh] bg-white p-6 rounded-lg shadow-lg flex flex-col xxl:max-w-[650px]">
			<div className="relative flex items-center justify-center">
				{images.length > 1 && (
					<>
						<button className="absolute left-0 z-10 p-2 rounded-full hover:bg-gray-300" onClick={() => changeImage(-1)}>
							<Arrow className="rotate-180" />
						</button>
						<button className="absolute right-0 z-10 p-2 rounded-full hover:bg-gray-300" onClick={() => changeImage(1)}>
							<Arrow />
						</button>
					</>
				)}
				<Image image={images[currentIndex]} className="max-w-lg max-h-[95vh] xxl:max-w-[650px]" />
			</div>
		</Modal>
	);
};

const ExpandedMedia = ({ data }) => {
	const {
		videoUrl, images = [], contentIcon, contentTitle, modalButton, videoButton, videoTitle, contentType, video
	} = data.expandedMediaContent;
	const [isModalOpen, setIsModalOpen] = useState(false);
	const videoId = videoUrl?.split(/watch\?v=|embed\//)[1] || null;
	const isVideoAvailable = video?.url || videoId;

	return (
		<>
			<ExpandedMediaModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} images={images} />
			<div className="flex flex-col md:flex-row items-center gap-4 p-6 bg-cream">
				<div className={clsx("w-full flex flex-col items-start gap-y-4 sm:order-first order-last",
					isVideoAvailable && "md:w-1/3")}>
					{contentTitle && (
						<>
							<div className="flex items-center">
								<Image image={contentIcon} className="size-4 mr-2" />
								<h6 className="font-base text-sm text-secondary uppercase">{contentType}</h6>
							</div>
							<h1 className="sm:text-h1-xs text-h4 font-bold">{contentTitle}</h1>
						</>
					)}
					<div className="text-secondary text-base font-base">
						<RichText data={data} />
					</div>
					{modalButton && (
						<button
							className="btn-tertiary border-none whitespace-nowrap hover:bg-transparent 
						 hover:text-beige !normal-case tracking-tight pl-1 text-base"
							onClick={() => setIsModalOpen(true)}
						>
							{modalButton}
							<GoldArrow className="ml-1 scale-75" />
						</button>
					)}
				</div>
				{isVideoAvailable &&
					<div className="relative w-[325px] sm:w-2/3 md:pl-10 aspect-video md:aspect-[16/8]">
						<Video data={{ shopifyVideo: video, url: videoUrl, videoTitle, videoButton, prioritizeYouTube: true }} />
					</div>}
			</div>
		</>
	);
};

export default ExpandedMedia;